<template>
  <v-row justify="center">
    <v-col cols="12">
      <v-card>
        <v-card-text>
          <v-row class="justify-center">
            <v-col
              cols="12"
              md="12"
            >
              <v-form
                ref="form_all"
                v-model="valid"
              >
                <v-tabs
                  centered
                  show-arrows
                >
                  <v-tab>
                    <v-icon left>
                      mdi-text-box-outline
                    </v-icon>Информация
                  </v-tab>
                  <v-tab v-if="form.device">
                    <v-icon left>
                      mdi-connection
                    </v-icon>Параметры подключения
                  </v-tab>
                  <v-tab>
                    <v-icon left>
                      mdi-folder
                    </v-icon>Файлы
                  </v-tab>
                  <v-tab
                    v-if="form.device"
                    @click="refresh(form, false)"
                  >
                    <v-icon left>
                      mdi-certificate
                    </v-icon>Карточка регистрации
                  </v-tab>
                  <v-tab v-if="form.id">
                    <v-icon left>
                      mdi-list-status
                    </v-icon>Состояние
                  </v-tab>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="10"
                        xl="8"
                      >
                        <v-row class="justify-center">
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="form.created"
                              label="Дата создания"
                              type="date"
                              :disabled="true"
                              outlined
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="form.number"
                              label="Системный номер"
                              :disabled="true"
                              outlined
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-select
                              v-model="form.state"
                              label="Статус"
                              :items="select.state"
                              :disabled="!form.id"
                              outlined
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-select
                              v-model="form.device"
                              label="Модель"
                              :items="select.device.filter(a=>a.type == form.type)"
                              item-text="model"
                              item-value="id"
                              outlined
                              @change="device_selected"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="form.serial"
                              label="Серийный номер"
                              outlined
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="form.settings.sn"
                              label="Серийный номер ККТ"
                              :disabled="true"
                              outlined
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="form.made"
                              type="date"
                              label="Дата производства"
                              outlined
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="form.start"
                              type="date"
                              label="Дата ввода в эксплуатацию"
                              :disabled="true"
                              outlined
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-text-field
                              v-model="form.end"
                              type="date"
                              label="Дата вывода из эксплуатации"
                              :disabled="true"
                              outlined
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col
                            cols="12"
                          >
                            <v-select
                              v-model="form.ffd_version"
                              label="Версия фискализации"
                              outlined
                              :items="select.ffd"
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col cols="12">
                            <v-autocomplete
                              v-if="$store.state.access[14][5]"
                              v-model="form.client"
                              clearable
                              :filter="client_filter"
                              :items="select.clients"
                              item-value="id"
                              label="Поиск клиента"
                              :loading="search.client.loading"
                              :search-input.sync="search.client.text"
                              hide-no-data
                              hint="Введите минимум три символа для поиска"
                              outlined
                              @change="client_selected"
                            >
                              <template v-slot:selection="{item}">
                                <v-list>
                                  <v-list-item-content>
                                    <v-list-item-title> {{ item.legal.name.short }}</v-list-item-title>
                                  </v-list-item-content>
                                </v-list>
                              </template>
                              <template v-slot:item="{item}">
                                <v-list two-line>
                                  <v-list-item-content>
                                    <v-list-item-title>  {{ item.legal.name.short }}</v-list-item-title>
                                    <v-list-item-subtitle>ИНН: {{ item.legal.inn }} КПП: {{ item.legal.kpp }}</v-list-item-subtitle>
                                  </v-list-item-content>
                                </v-list>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col cols="12">
                            <v-text-field
                              v-model="form.comment"
                              label="Примечание"
                              outlined
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col cols="12">
                            <v-checkbox
                              v-model="form.settings.send_vending"
                              label="Передавать номер устройства"
                              outlined
                            />
                            <v-select
                              v-if="form.settings.send_vending"
                              v-model="form.settings.send_vending_type"
                              :items="[
                                {
                                  value: '1',
                                  text: 'Номер точки'
                                },
                                {
                                  value: '2',
                                  text: 'Данные API'
                                },
                                {
                                  value: '3',
                                  text: 'Задать значение'
                                }]"
                              label="Выберите способ"
                            />
                            <v-text-field
                              v-if="form.settings.send_vending && form.settings.send_vending_type == '3'"
                              v-model="form.settings.vending_number"
                              label="Номер автомата"
                              outlined
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col cols="12">
                            <v-checkbox
                              v-model="form.settings.send_place"
                              label="Передавать место обслуживания"
                              outlined
                            />
                            <v-select
                              v-if="form.settings.send_place"
                              v-model="form.settings.send_place_type"
                              :items="[
                                {
                                  value: '1',
                                  text: 'Название точки'
                                },
                                {
                                  value: '2',
                                  text: 'Данные API'
                                },
                                {
                                  value: '3',
                                  text: 'Задать значение'
                                },
                                {
                                  value: '4',
                                  text: 'Из оборудования'
                                }]"
                              label="Выберите способ"
                            />
                            <v-text-field
                              v-if="form.settings.send_place && form.settings.send_place_type == '3'"
                              v-model="form.settings.place_name"
                              label="Место обслуживания"
                              outlined
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col cols="12">
                            <v-checkbox
                              v-model="form.settings.send_address"
                              label="Передавать адрес расчётов"
                              outlined
                            />
                            <v-select
                              v-if="form.settings.send_address"
                              v-model="form.settings.send_address_type"
                              :items="[
                                {
                                  value: '1',
                                  text: 'Адрес места обслуживания'
                                },
                                {
                                  value: '2',
                                  text: 'Данные API'
                                },
                                {
                                  value: '3',
                                  text: 'Задать значение'
                                },
                                {
                                  value: '4',
                                  text: 'Из оборудования'
                                }]"
                              label="Выберите способ"
                            />
                            <v-text-field
                              v-if="form.settings.send_address && form.settings.send_address_type == '3'"
                              v-model="form.settings.address_name"
                              label="Адрес рассчетов"
                              outlined
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item v-if="form.device">
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="10"
                        xl="8"
                      >
                        <v-data-table
                          v-if="select.device.filter(a=>a.id == form.device)[0]"
                          :items="select.device.filter(a=>a.id == form.device)[0].settings.filter(a=>form.settings.connection && form.settings.connection.indexOf(a.key)>-1)"
                          :headers="[
                            {value: 'description', text: 'Описание', width: 300},
                            {value: 'value', text: 'Значение', width: 150},
                          ]"
                          :footer-props="datatable_footer"
                          no-data-text="Нет данных для отображения"
                        >
                          <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                            {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                          </template>
                          <template v-slot:item.description="{item}">
                            <v-text-field
                              v-model="item.description"
                              readonly
                              outlined
                              @input="settings_change(item)"
                            />
                          </template>

                          <template v-slot:item.value="{item}">
                            <v-text-field
                              v-if="item.type == 0"
                              v-model="form.settings[item.key]"
                              outlined
                              @input="settings_change(item)"
                            />
                            <v-checkbox
                              v-if="item.type == 1"
                              v-model="form.settings[item.key]"
                              outlined
                              @change="settings_change(item)"
                            />
                            <v-select
                              v-if="item.type == 2"
                              v-model="form.settings[item.key]"
                              :items="item.values"
                              outlined
                              @change="settings_change(item)"
                            />
                            <v-textarea
                              v-if="item.type == 3"
                              v-model="form.settings[item.key]"
                              outlined
                              @input="settings_change(item)"
                            />
                            <div
                              v-if="item.type == 4"
                              class="d-flex flex-row justify-space-between align-baseline"
                            >
                              <v-text-field
                                v-model="form.settings[item.key]"
                                readonly
                                outlined
                                @click="$refs[`upload_settings_${item.key}`].click()"
                              />
                              <v-btn
                                icon
                                @click="$refs[`upload_settings_${item.key}`].click()"
                              >
                                <v-icon>
                                  mdi-paperclip
                                </v-icon>
                              </v-btn>
                              <input
                                :ref="`upload_settings_${item.key}`"
                                type="file"
                                style="display: none;"
                                @change="upload_settings_file($event, item.key)"
                              >
                            </div>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="10"
                        xl="8"
                      >
                        <v-form>
                          <v-container class="py-0">
                            <v-card
                              class="elevation-1"
                              text
                            >
                              <v-progress-linear
                                class="ma-0"
                                color="secondary"
                                :indeterminate="loader.show"
                              />
                              <v-card-text>
                                <v-data-table
                                  hide-default-footer
                                  hide-default-header
                                  :items="form.files"
                                  :headers="table.headers"
                                  no-data-text="Нет данных для отображения"
                                >
                                  <template v-slot:item.save="{item}">
                                    <v-icon @click="getDoc(item)">
                                      mdi-content-save
                                    </v-icon>
                                  </template>
                                  <template v-slot:item.comment="{item}">
                                    <v-text-field
                                      v-model="item.comment"
                                      :disabled="loader.show || view"
                                      label="Описание"
                                    />
                                  </template>
                                  <template v-slot:item.delete="{item}">
                                    <v-btn
                                      icon
                                      @click="form.files = form.files.filter((a) => a !== item)"
                                    >
                                      <v-icon>
                                        mdi-close
                                      </v-icon>
                                    </v-btn>
                                  </template>
                                </v-data-table>
                              </v-card-text>
                              <v-card-actions class="grey lighten-4">
                                <v-btn
                                  color="primary"
                                  text
                                  :disabled="loader.show || view"
                                  @click="$refs.upload.click()"
                                >
                                  Добавить файл
                                </v-btn>
                                <input
                                  ref="upload"
                                  type="file"
                                  style="display: none;"
                                  @change="upload"
                                >
                              </v-card-actions>
                            </v-card>
                          </v-container>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item v-if="form.device">
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="10"
                        xl="8"
                      >
                        <v-row class="justify-center">
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-text-field
                              v-model="form.settings.owner_name"
                              label="Наименование пользователя"
                              outlined
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-text-field
                              v-model="form.settings.owner_inn"
                              label="ИНН пользователя"
                              outlined
                              :rules="[v=>!settings.owner_inn || v == settings.owner_inn || 'Не совпадает ИНН: ' + settings.owner_inn]"
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-text-field
                              v-model="form.settings.owner_address"
                              label="Адрес рассчетов"
                              outlined
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-text-field
                              v-model="form.settings.owner_place"
                              label="Место установки"
                              outlined
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-text-field
                              v-model="form.settings.ofd_name"
                              label="Наименование ОФД"
                              outlined
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-text-field
                              v-model="form.settings.ofd_inn"
                              label="ИНН ОФД"
                              :rules="[v=>!settings.ofd_inn || v == settings.ofd_inn || 'Не совпадает ИНН: ' + settings.ofd_inn]"
                              outlined
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col cols="12">
                            <v-text-field
                              v-model="form.settings.ofd_email"
                              label="E-mail отправителя чеков"
                              outlined
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-text-field
                              v-model="form.settings.ofd_server"
                              label="Адрес сервера ОФД"
                              outlined
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-text-field
                              v-model="form.settings.ofd_port"
                              label="Порт подключения"
                              outlined
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-select
                              v-model="form.settings.tax_system"
                              label="Налоговый режим"
                              outlined
                              :items="select.tax"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-text-field
                              v-model="form.settings.tax_url"
                              label="Сайт налоговой"
                              outlined
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col
                            cols="12"
                            md="8"
                          >
                            <v-select
                              v-model="form.settings.agent_type"
                              label="Тип агента"
                              outlined
                              :items="select.agent"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="4"
                          >
                            <v-checkbox
                              v-model="form.settings.use_default_agent"
                              label="Использовать по умолчанию"
                              outlined
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col cols="12">
                            <v-text-field
                              v-model="form.settings.agent_phone"
                              label="Телефон агента"
                              outlined
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="form.settings.rn"
                              label="РН ККТ"
                              :rules="[v=>!settings.rn || v == settings.rn || 'Не совпадает РН ККТ: ' + settings.rn]"
                              outlined
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="form.settings.sn"
                              label="СН ККТ"
                              outlined
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="form.settings.number"
                              label="Номер фискального накопителя"
                              :rules="[v=>!settings.number || v == settings.number || 'Не совпадает ФН: ' + settings.number]"
                              outlined
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-space-between">
                          <v-col
                            cols="12"
                            md="6"
                            lg="3"
                          >
                            <v-btn
                              color="secondary"
                              outlined
                              :disabled="settings.loading"
                              @click="refresh(form, true)"
                            >
                              <span class="mx-10">
                                ДАННЫЕ ККТ
                              </span>
                            </v-btn>
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                            lg="3"
                            class="text-right"
                          >
                            <v-btn
                              color="secondary"
                              :disabled="settings.loading || !!settings.number"
                              @click="register(form)"
                            >
                              <span class="mx-10">
                                РЕГИСТРАЦИЯ ККТ
                              </span>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row class="justify-center">
                      <v-col
                        cols="12"
                        md="10"
                        xl="8"
                      >
                        <v-row class="justify-center">
                          <v-col cols="12">
                            <v-checkbox
                              v-model="form.settings.autosession"
                              label="Автоматическое открытие/закрытие смены"
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-text-field
                              v-model="form.settings.cashier_name"
                              label="Имя кассира"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-text-field
                              v-model="form.settings.cashier_inn"
                              label="ИНН кассира"
                            />
                          </v-col>
                        </v-row>
                        <v-row
                          v-if="form.settings.autosession"
                          class="justify-center"
                        >
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-text-field
                              v-model="form.settings.open_session_at"
                              label="Время открытия смены"
                              type="time"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-text-field
                              v-model="form.settings.close_session_at"
                              label="Время закрытия смены"
                              type="time"
                            />
                          </v-col>
                        </v-row>
                        <v-row class="justify-center">
                          <v-col
                            cols="12"
                            md="6"
                          >
                            {{ form.settings.session_state == "open" ? "Смена открыта": (form.settings.session_state == "close" ? "Смена закрыта": "Неизвестное состояние") }}
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <v-btn
                              v-if="!form.settings.session_state || form.settings.session_state == 'close' || form.settings.session_state=='wait'"
                              color="primary"
                              class="ml-5"
                              @click="open_session(form)"
                            >
                              <span class="mx-5">Открыть смену</span>
                            </v-btn>
                            <v-btn
                              v-if="!form.settings.session_state || form.settings.session_state == 'open' || form.settings.session_state=='wait'"
                              color="primary"
                              class="ml-5"
                              @click="close_session(form)"
                            >
                              <span class="mx-5">Закрыть смену</span>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs>
              </v-form>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row class="justify-center">
            <v-col
              cols="6"
              md="3"
            >
              <v-btn
                color="primary"
                outlined
                @click="$router.go(-1)"
              >
                <span class="mx-3">Назад</span>
              </v-btn>
            </v-col>
            <v-col
              cols="6"
              md="3"
              class="text-right"
              :disabled="!valid"
            >
              <v-btn
                color="primary"
                class="ml-auto"
                @click="save"
              >
                <span class="mx-3">Сохранить</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  import suggest from '../../../libs/suggestions.min.17.12.0.dev.js'
  import { changeTzToHours } from "@/views/loyalty/shared/modules/utilities"
  export default {
    data: () => ({
      valid: false,
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
      menu: {
        from: false,
        to: false
      },
      selected: {
      },
      info: {

      },
      loader: {
        show: false,
      },
      dialog: {
        event: {
          show: false,
          item: {},
        },

      },
      events: [

      ],
      table: {
        headers: [
          {
            text: '',
            value: 'save',
          },
          {
            text: 'Название',
            value: 'name',
          },
          {
            text: 'Описание',
            value: 'comment',
          },
          {
            text: 'Удалить',
            value: 'delete'
          }
        ],
      },
      tabs: [
        'Основные',
        'Настройки',
        'Файлы',
      ],
      data: {
        phone: '',
      },
      form: {
        files: [],
        settings: [
          {
            new: true,
            values: []
          }
        ],
        type: 4,
        ffd_version: 0
      },
      logs: [],
      dict: {
        insurer: {},
        phone: {
          1: 'Мобильный',
          2: 'Домашний',
        },
        address: {
          1: 'Юридический адрес',
          2: 'Фактический адрес',
        },
        file: {
          type: {
            0: 'Без типа',
            1: 'Слайдер в описании проекта',
            2: 'Договор поручительства',
            3: 'Документы проекта',
          },
        },
        event: {
          1: 'Звонок',
          2: 'SMS сообщение',
          3: 'Email сообщение',
          4: 'Встреча',
          5: 'Другое',
        },
      },
      select: {
        clients: [],
        type: [
        ],
        state: [
          { value: 0, text: 'На складе' },
          { value: 1, text: 'Ожидает ввода в эксплуатацию' },
          { value: 2, text: 'Эксплуатируется' },
          { value: 3, text: 'Ремонт' },
          { value: 4, text: 'Утилизация' },
          { value: 5, text: 'Временно выведен из эксплуатации' }
        ],
        device: [],
        agent: [
          {
            value: 'AGENT', text: 'Агент'
          },
          {
            value: 'ATTORNEY_AGENT', text: 'Поверенный'
          },
          {
            value: 'BANK_PAYING_AGENT', text: 'Банковский платежный агент'
          },
          {
            value: 'BANK_PAYING_SUBAGENT', text: 'Банковский платежный субагент'
          },
          {
            value: 'COMMISSION_AGENT', text: 'Комиссионер'
          },
          {
            value: 'PAYING_AGENT', text: 'Платежный агент'
          },
          {
            value: 'PAYING_SUBAGENT', text: 'Платежный субагент'
          }
        ],
        tax: [
          {
            value: 'ENVD', text: 'ЕНВД'
          },
          {
            value: 'ESN', text: 'ЕСН'
          },
          {
            value: 'OSN', text: 'Общая, ОСН'
          },
          {
            value: 'PATENT', text: 'Патент'
          },
          {
            value: 'USN_INCOME', text: 'УСН доход'
          },
          {
            value: 'USN_INCOME_CONSUMPTION', text: 'УСН доход - расход'
          }
        ],
        ffd: [
          {
            value: 0, text: 'ФФД 1.05'
          },
          {
            value: 1, text: 'ФФД 1.2'
          }
        ]
      },
      suggestion: {
        address: false
      },
      search: {
        client: {
          loading: false,
          text: ''
        },
      },
      settings: {
        loading: false
      }
    }),
    watch: {
      'search.client.text': function () {
        if (this.search.client.text) { this.load_clients(this.search.client.text) }
      },
    },
    mounted: function () {
      if (this.create) {
        this.form.created = moment().format('YYYY-MM-DD')
      }
      this.axios.post('/api/device/list', {})
        .then(result => {
            if (!result.data.error) {
              this.select.device = result.data.data.filter(a => a.state == 0)
            }
          })
          .catch(e => {
            console.log(e)
          })
        for (const x in this.$store.state.dict.device_type) {
          this.select.type.push({
            value: Number(x),
            text: this.$store.state.dict.device_type[x].name
          })
        }
      this.load()
    },
    methods: {
      load: function () {
         var id = this.$route.query.id
        if (id) {
          this.axios.post('/api/equipment/list', { id: id })
            .then(result => {
              if (!result.data.error) {
                this.form = result.data.data[0]
                if (this.form.created) this.form.created = moment(this.form.created).format('YYYY-MM-DD')
                this.form.schedule = this.form.schedule || {}
                this.form.files = this.form.files || []
                if (this.form.start) this.form.start = moment(this.form.start).format('YYYY-MM-DD')
                if (this.form.end) this.form.end = moment(this.form.end).format('YYYY-MM-DD')
                if (this.form.made) this.form.made = moment(this.form.made).format('YYYY-MM-DD')
                if (this.form.client) {
                  this.load_clients_id(this.form.client)
                }
                if (this.form.settings.open_session_at) {
                  this.form.settings.open_session_at = changeTzToHours(this.form.settings.open_session_at, false)
                }
                if (this.form.settings.close_session_at) {
                  this.form.settings.close_session_at = changeTzToHours(this.form.settings.close_session_at, false)
                }
              }
            })
            .catch(e => {
              console.log(e)
            })
        }
      },
      refresh: function (item, replace) {
        this.settings.loading = true
        this.axios.post('/api/fiscal/getinfo', item)
          .then(result => {
              this.settings.loading = false
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Данные ККТ успешно получены')
                this.settings = result.data.data
                this.$refs.form_all.validate()
                if (replace) { item.settings = result.data.data }
              } else {
                this.$store.commit('snackbar', 'Ошибка при обновлении')
              }
            })
            .catch(error => {
              this.settings.loading = false
              this.$store.commit('snackbar', 'Ошибка при обновлении')
            })
      },
       register: function (item) {
        this.settings.loading = true
        this.axios.post('/api/fiscal/register', item)
          .then(result => {
              this.settings.loading = false
              if (!result.data.error) {
                this.$store.commit('snackbar', 'ККТ успешно зарегистрирован')
                this.refresh(item, true)
              } else {
                this.$store.commit('snackbar', 'Ошибка при обновлении')
              }
            })
            .catch(error => {
              this.settings.loading = false
              this.$store.commit('snackbar', 'Ошибка при обновлении')
            })
      },
      open_session: function (item) {
        this.settings.loading = true
        // item2 is deep copy of item
        const item2 = JSON.parse(JSON.stringify(item))
        if (item2.settings.open_session_at) {
          item2.settings.open_session_at = changeTzToHours(item2.settings.open_session_at)
        }
        if (item2.settings.close_session_at) {
          item2.settings.close_session_at = changeTzToHours(item2.settings.close_session_at)
        }
        this.axios.post('/api/fiscal/session/open', item2)
          .then(result => {
              this.settings.loading = false
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Смена успешно открыта')
                this.load()
              } else {
                this.$store.commit('snackbar', 'Ошибка при обновлении')
                this.load()
              }
            })
            .catch(error => {
              this.settings.loading = false
              this.$store.commit('snackbar', 'Критическая ошибка при обновлении')
            })
      },
      close_session: function (item) {
        this.settings.loading = true
        // item2 is deep copy of item
        const item2 = JSON.parse(JSON.stringify(item))
        if (item2.settings.open_session_at) {
          item2.settings.open_session_at = changeTzToHours(item2.settings.open_session_at)
        }
        if (item2.settings.close_session_at) {
          item2.settings.close_session_at = changeTzToHours(item2.settings.close_session_at)
        }
        this.axios.post('/api/fiscal/session/close', item2)
          .then(result => {
              this.settings.loading = false
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Смена успешно закрыта')
                this.load()
              } else {
                this.$store.commit('snackbar', 'Ошибка при обновлении')
                this.load()
              }
            })
            .catch(error => {
              this.settings.loading = false
              this.$store.commit('snackbar', 'Критическая ошибка при обновлении')
            })
      },
      client_selected: function () {
          var client = this.select.clients.filter(a => a.id == this.form.client)[0]
          console.log(client)
          this.form.settings.owner_name = client.legal.name.short
          this.form.settings.owner_inn = client.legal.inn
          this.form.settings.owner_address = client.addresses.filter(a => a.type == 1)[0].value
          this.form.settings.owner_place = ''
      },
      device_selected: function () {
        if (this.form.device) {
          const device = this.select.device.filter(a => a.id == this.form.device)[0]
          if (device) {
            this.form.settings = {}
            for (const x in device.settings) {
              this.form.settings[device.settings[x].key] = device.settings[x].default_value
            }
          }
        }
      },
      client_filter: function (item, query, text) {
        if (item.legal && (item.legal.name.full).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.name.short).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.kpp).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.inn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.ogrn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      load_clients: function (text) {
        this.search.client.loading = true
        this.axios.post('/api/client/list', {
          search: text,
          limit: 10
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      load_clients_id: function (id) {
        if (!id) return
        this.axios.post('/api/client/list', {
          id: id
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      upload: function (event) {
        const files = event.target.files
        if (files[0]) {
          this.loader.show = true
          const data = new FormData()
          data.append('file', files[0])
          this.axios
            .post('/api/common/file/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              } else {
                for (const x in response.data.data) {
                  this.form.files.push(response.data.data[x])
                }

                console.log(this.form.files)
              }
              this.loader.show = false
            })
            .catch(error => {
              console.log(error)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              this.loader.show = false
            })
        }
      },
      upload_settings_file: function (event, key) {
        const files = event.target.files
        if (files[0]) {
          this.loader.show = true
          const data = new FormData()
          data.append('file', files[0])
          this.axios
            .post('/api/common/file/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              } else {
                for (const x in response.data.data) {
                  this.form.files.push(response.data.data[x])
                  this.form.settings[key] = response.data.data[x].name || response.data.data[x].filename
                }
                console.log(this.form.files)
              }
              this.loader.show = false
            })
            .catch(error => {
              console.log(error)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              this.loader.show = false
            })
        }
      },
      delete_settings_file (key) {

      },
      settings_change: function (item) {
        console.log(item)
        if (item.new) {
          item.new = false
          this.form.settings.push({
            new: true,
            type: 0,
            values: []
          })
        }
      },
      get_color: function (item, type) {
        return 'white'
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      getDoc: function (item) {
        console.log(item)
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file/get',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      open_file: function (id, item) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: id,
            name: 'id',
          })
        )
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item,
            name: 'name',
          })
        )
        form.appendTo('body').submit()
      },
      adress_input: function (item) {
        if (!this.suggestion.address) {
          console.log('[name=address]')
          this.suggestion.address = true
          $('[name=address]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              this.form.address = data.unrestricted_value
              this.form.address_data = data.data
            },
          })
        }
      },
      check_valid: function () {
        if (!this.$refs.form_all.validate()) return false
        if (this.settings.ofd_inn && this.settings.ofd_inn != this.form.settings.ofd_inn) return false
        if (this.settings.owner_inn && this.settings.owner_inn != this.form.settings.owner_inn) return false
        if (this.settings.rn && this.settings.rn != this.form.settings.rn) return false
        if (this.settings.number && this.settings.number != this.form.settings.number) return false
        return true
      },
      save: function () {
        if (!this.check_valid()) {
          this.$store.commit('snackbar', 'Некорректно заполнены данные')
          return
        }
        let url = '/api/equipment/save'
        if (!this.form.id) {
          url = '/api/equipment/create'
        }
        console.log('this.form', this.form)
        if (this.form.settings.open_session_at) {
          this.form.settings.open_session_at = changeTzToHours(this.form.settings.open_session_at)
        }
        if (this.form.settings.close_session_at) {
          this.form.settings.close_session_at = changeTzToHours(this.form.settings.close_session_at)
        }
          this.axios.post(url, this.form)
            .then(result => {
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Данные успешно сохранены')
                this.$router.go(-1)
              } else {
                this.$store.commit('snackbar', result.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', e || 'Ошибка при сохранении данных')
            })
      },
    },
  }
</script>
